import { StreamActions } from "@hotwired/turbo"
import {Utils} from "turbo_power";
import { Offcanvas } from "bootstrap"

const PERMITTED_ATTRIBUTES = [

]

// https://github.com/simple-notify/simple-notify
function offcanvas() {
  console.log(this.attributes)

  // const attributes = Array.from(this.attributes)
  //   .filter((attribute) => PERMITTED_ATTRIBUTES.includes(attribute.name))
  //   .map((attribute) => [Utils.camelize(attribute.name), Utils.typecast(attribute.value)])
  //
  // const options = Object.fromEntries(attributes)

  this.targetElements.forEach((element) => {
    var bsOffcanvas = Offcanvas.getOrCreateInstance(element)
    bsOffcanvas.show()
  })
}

StreamActions.offcanvas = offcanvas
